import { useMemo } from "react";
import { I18nextProvider, useTranslation } from "react-i18next";
import i18n, { changeLanguage } from "@/i18n";

export function getNetworkErrorToastMessage() {
  return i18n.t("network_error_toast");
}

export function LangProvider({ children }) {
  return <I18nextProvider i18n={i18n}>{children}</I18nextProvider>;
}

export function useLang() {
  const { t, i18n: instance } = useTranslation();
  const lang = instance.resolvedLanguage || instance.language;
  return useMemo(() => ({ lang, t, setLang: changeLanguage }), [lang, t]);
}
